var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180218",
    "data-name": "Group 180218",
    transform: "translate(-244 -191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146603",
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(244 191)",
    fill: "#f2f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_179280",
    "data-name": "Group 179280",
    transform: "translate(162 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29642",
    "data-name": "Path 29642",
    d: "M2.846,1H15.154A1.846,1.846,0,0,1,17,2.846V15.154A1.846,1.846,0,0,1,15.154,17H2.846A1.846,1.846,0,0,1,1,15.154V2.846A1.846,1.846,0,0,1,2.846,1Zm0,1.231a.615.615,0,0,0-.615.615v7.217L4.3,7.993a.554.554,0,0,1,.8.014L9.46,12.68l3.456-3.456a.554.554,0,0,1,.783,0l2.07,2.07V2.846a.615.615,0,0,0-.615-.615ZM2.231,15.154V11.629L4.679,9.182l4.36,4.67,1.735,1.917H2.846A.615.615,0,0,1,2.231,15.154Zm12.923.615H12.268L10.21,13.5l3.1-3.1,2.462,2.462v2.294A.615.615,0,0,1,15.154,15.769Z",
    transform: "translate(89 171)",
    fill: "#203662",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146710",
    "data-name": "Rectangle 146710",
    width: 7,
    height: 7,
    transform: "translate(99 172)",
    fill: "#f2f6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_114",
    "data-name": "Union 114",
    d: "M-5269.376-14139.8v-2.624H-5272v-.951h2.624V-14146h.952v2.624h2.624v.951h-2.624v2.624Z",
    transform: "translate(5371.801 14318)",
    fill: "#203662"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageblue);
export default __webpack_public_path__ + "static/media/Imageblue.78c30e7219675c1ab9c6ef63a8886c88.svg";
export { ForwardRef as ReactComponent };